import { render } from "./LootBoxListModal.vue?vue&type=template&id=04ec6b73"
import script from "./LootBoxListModal.vue?vue&type=script&lang=js"
export * from "./LootBoxListModal.vue?vue&type=script&lang=js"

import "./LootBoxListModal.vue?vue&type=style&index=0&id=04ec6b73&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__